import ApiService from "./api.service";
export default class UnavailableZoneService extends ApiService {
    static base_url = `${super.base_url}/unavailable_zones/public`;
}
